import React from "react";
import { Spin, Select } from "antd";

import { compose, config } from "src/helpers";
import { Field, RenderSelect } from "src/components";

import { withOrders } from "src/modules/order/operations";

import { withStateAndActionsForOrder } from "../resolvers";

const Option = Select.Option;

const SubjectsField = (props) => {
    const { loading, orders, where, onNameChange, onChange, value } = props;

    return (
        <Field
            labelInValue
            showSearch={true}
            filterOption={false}
            onSearch={onNameChange}
            notFoundContent={loading ? <Spin size="small" /> : null}
            name={"orders"}
            component={RenderSelect}
            placeholder={"Orders"}
            label={"Orders"}
            value={value || "None"}
            loading={loading}
            onChange={onChange}
            inFilter={true}
            noBotMarging={true}
        >
            {[
                // config.EMPTY_OPTION,
                ...(orders?.map((order) => ({
                    id: order.id,
                    label: order.name || "",
                    value: JSON.stringify(order),
                })) || []),
            ]?.map(
                ({
                    id,
                    value,
                    label = "",
                }: {
                    id: string;
                    value: string;
                    label: string;
                }) => (
                    <Option key={id} value={value}>
                        {label}
                    </Option>
                ),
            )}
        </Field>
    );
};

export default compose(withStateAndActionsForOrder, withOrders)(SubjectsField);
